import React from "react";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import styles from "./CommunityImportsTab.module.css";
import ImportProjectsModal from "../ImportProjectsModal/ImportProjectsModal";

type Props = {
  communityGuid: string;
  communityName?: string;
};

/**
 * Community Settings → Imports tab.
 * Renders the shared ImportProjectsModal in embedded mode with the
 * community pre-selected and locked.
 */
const CommunityImportsTab: React.FC<Props> = ({ communityGuid, communityName }) => {
  const { t } = useAppTranslation('community');
  return (
    <div className={styles.wrap}>
      <div className={styles.panel}>
        <div className={styles.panelHeader}>
          <h3 className={styles.panelTitle}>{t('imports.title')}</h3>
          <div className={styles.panelSubtitle}>
            {t('imports.description', { community: communityName || communityGuid || "this community" })}
          </div>
        </div>
        <div className={styles.panelBody}>
          <ImportProjectsModal
            isOpen={true}
            onClose={() => {}}
            mode="embedded"
            communityGuid={communityGuid}
            communityName={communityName}
          />
        </div>
      </div>
    </div>
  );
};

export default CommunityImportsTab;
